import { Injectable, Inject } from "@angular/core";
import { ShaderProgram } from "../shaders/shader-program";
import { PBR_SHADER } from "../shaders/shader-program.module";
import { WEBGL2, GLTF } from "../webgl2/webgl2-token";
import { MainCamera } from "../game-engine/main-camera";
import { Vec3, Transform } from "../game-engine/transform";
import { Mesh } from "../geometry/mesh";
import { MaterialLoader } from "../materials/material-loader";
import { BufferLoader } from "../webgl2/buffer-loader";
import { InputManager } from "../game-engine/input-manager";
var SceneRenderer = (function () {
    function SceneRenderer(gl_context_, gltf_data_, input_manager_, pbr_shader_, material_loader_, buffer_loader_) {
        this.gl_context_ = gl_context_;
        this.gltf_data_ = gltf_data_;
        this.input_manager_ = input_manager_;
        this.pbr_shader_ = pbr_shader_;
        this.material_loader_ = material_loader_;
        this.buffer_loader_ = buffer_loader_;
        this.light_direction = new Vec3(0.4, 0.4, 1.0);
        this.current_direction = new Vec3();
        this.meshes = [];
    }
    ;
    SceneRenderer.prototype.constructScene = function () {
        var _this = this;
        var index = this.gltf_data_.scene;
        if (typeof index !== "number")
            return;
        this.gltf_data_.scenes[index].nodes.forEach(function (index) {
            var node = _this.gltf_data_.nodes[index];
            var node_transform;
            if (node.matrix) {
                node_transform = Transform.fromMatrix(node.matrix);
            }
            else {
                node_transform = new Transform(node.translation, node.rotation, node.scale);
            }
            if (node.camera > -1) {
                _this.main_camera_ = new MainCamera(_this.input_manager_);
                console.log(_this.main_camera_);
            }
            if (node.mesh > -1) {
                var mesh = new Mesh(_this.gl_context_, _this.gltf_data_, node.mesh, node_transform, _this.material_loader_, _this.buffer_loader_);
                console.log(mesh);
                _this.meshes.push(mesh);
            }
        });
        this.loadMeshes();
        this.start();
    };
    ;
    SceneRenderer.prototype.loadMeshes = function () {
        this.meshes.forEach(function (mesh) { return mesh.createMesh(); });
    };
    ;
    SceneRenderer.prototype.start = function () {
        this.main_camera_.initialiseCamera(this.gltf_data_.cameras[0].perspective);
        this.pbr_shader_.initProgram();
    };
    ;
    SceneRenderer.prototype.updateScene = function (dt) {
        var _this = this;
        this.main_camera_.updateCamera(dt);
        var view = this.main_camera_.view.array;
        this.current_direction.x = view[0] * this.light_direction.x + view[4] * this.light_direction.y + view[8] * this.light_direction.z;
        this.current_direction.y = view[1] * this.light_direction.x + view[5] * this.light_direction.y + view[9] * this.light_direction.z;
        this.current_direction.z = view[2] * this.light_direction.x + view[6] * this.light_direction.y + view[10] * this.light_direction.z;
        this.meshes.forEach(function (mesh) {
            mesh.preMultiplyMatrices(_this.main_camera_.view, _this.main_camera_.projection);
        });
    };
    ;
    SceneRenderer.prototype.drawObjects = function () {
        var _this = this;
        this.pbr_shader_.useProgram();
        this.gl_context_.uniform3fv(this.pbr_shader_.getUniform("u_light_direction"), this.current_direction.array);
        this.gl_context_.uniform3fv(this.pbr_shader_.getUniform("u_light_color"), [1.0, 1.0, 1.0]);
        this.meshes.forEach(function (mesh) { return mesh.drawMesh(_this.pbr_shader_); });
    };
    ;
    SceneRenderer.decorators = [
        { type: Injectable },
    ];
    SceneRenderer.ctorParameters = function () { return [
        { type: WebGL2RenderingContext, decorators: [{ type: Inject, args: [WEBGL2,] },] },
        { type: undefined, decorators: [{ type: Inject, args: [GLTF,] },] },
        { type: InputManager, },
        { type: ShaderProgram, decorators: [{ type: Inject, args: [PBR_SHADER,] },] },
        { type: MaterialLoader, },
        { type: BufferLoader, },
    ]; };
    return SceneRenderer;
}());
export { SceneRenderer };
//# sourceMappingURL=scene-renderer.js.map